import React, { useContext } from 'react';
import i18n from '~/i18n';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import { useNavigate } from 'react-router-dom';
import { DialogContext } from '~/providers/DialogProvider';
import { CartActionContext } from '~/App/Layout/providers/CartProvider';
import { AppstoreAddOutlined } from '@ant-design/icons';
import { Order } from '@restaurant/api';

const useAddButton = ({ order }: { order: Order }) => {
  const { order: currentOrder, setOrder } = useContext(OrderContext);
  const navigate = useNavigate();
  const { openDialog } = useContext(DialogContext);
  const { resetCart, getAllCartItems } = useContext(CartActionContext);

  const onClick = () => {
    const proceed = () => {
      setOrder(order);
      navigate('/');
    };

    // check whether cart is filled with other order's item
    if (
      getAllCartItems().length &&
      (currentOrder.isNew || currentOrder.orderId !== order.orderId)
    ) {
      openDialog({
        message: i18n.t('dialog_order_detail_add'),
        okText: i18n.t('dialog_order_detail_add_ok'),
        cancelText: i18n.t('dialog_order_detail_add_cancel'),
        onOk: () => {
          resetCart();
          proceed();
        },
      });
    } else {
      proceed();
    }
  };

  return {
    key: 'add',
    text: i18n.t('cart_add_items'),
    icon: <AppstoreAddOutlined />,
    onClick,
  };
};

export default useAddButton;
